import { api } from '../api';
import { User } from '../../entities/User';

export const updateUser = async (userData: User): Promise<User> => {
  const { data } = await api.put('/users', userData);

  return data;
};
